import React from 'react';

const KeyMetrics = () => {
  return (
    <div className="mb-4">
      <h2 className="text-xl font-medium mb-3">Key Metrics</h2>
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-medium mb-2 text-gray-700">Response Assessment</h3>
          <div className="flex justify-center">
            <div className="w-20 h-20 rounded-full bg-green-200 flex items-center justify-center">
              <span className="text-xl font-bold">SD</span>
            </div>
          </div>
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-medium mb-2 text-gray-700">Toxicity Tracking</h3>
          <div className="flex justify-around items-end h-20">
            <div className="h-12 w-8 bg-green-500"></div>
            <div className="h-16 w-8 bg-orange-400"></div>
            <div className="h-8 w-8 bg-red-500"></div>
          </div>
          <div className="flex justify-around text-xs text-gray-600 mt-1">
            <span>GI</span>
            <span>Neuro</span>
            <span>HFS</span>
          </div>
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-medium mb-2 text-gray-700">Quality of Life</h3>
          <div className="h-20 flex items-center justify-center">
            <svg viewBox="0 0 100 30" className="w-full">
              <polyline
                points="0,15 20,10 40,20 60,5 80,15 100,10"
                fill="none"
                stroke="#3b82f6"
                strokeWidth="2"
              />
            </svg>
          </div>
          <div className="flex justify-between text-xs text-gray-600">
            <span>Apr</span>
            <span>Now</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyMetrics;